var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoSuperSelect = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "Logo-SuperSelect_svg__Gruppe_29",
  x: 0,
  y: 0,
  viewBox: "0 0 141.9 21.3"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Logo-SuperSelect_svg__st0{fill:#1d1d1b}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Logo-SuperSelect_svg__Gruppe_27",
  transform: "translate(0 2.622)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Logo-SuperSelect_svg__Pfad_41",
  d: "M3.3 17.2c-1.1 0-2.3-.1-3.3-.5v-4.1q1.65.6 3.3.6c.2 0 .5 0 .7-.1.1-.2.1-.4.1-.6 0-.6-.2-1-1.2-2.2L1.7 8.6C.8 7.5.2 6.2.2 4.8.2 1.8 1.9.1 5.4.1c1.1 0 2.2.1 3.3.4l-.3 3.8Q7.2 4 6 4c-1.2 0-1.3.2-1.3 1 0 .6.4 1.1 1.1 2l1.3 1.7c.9 1 1.4 2.4 1.4 3.7.1 2.7-1.7 4.8-5.2 4.8",
  className: "Logo-SuperSelect_svg__st0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Logo-SuperSelect_svg__Pfad_42",
  d: "M21.5 10.9c0 5.3-2.2 6.3-6 6.3-4.1 0-5.2-2-5.2-6.3V.4h4.3v10.2c0 .9.1 1.9.2 2.8.3.1.6.1 1 .1 1.1 0 1.5-.6 1.5-2.9V.4h4.3z",
  className: "Logo-SuperSelect_svg__st0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Logo-SuperSelect_svg__Pfad_43",
  d: "M29.7 12.5H28v4.4h-4.3V.4c1.3-.1 4-.2 5.9-.2 4 0 5.1 2 5.1 5.5 0 3.8-1.1 6.8-5 6.8M28 8.9h1.1c.9 0 1.3-.7 1.3-2.6q0-1.2-.3-2.4c-.2 0-.5-.1-.9-.1s-.8 0-1.2.1z",
  className: "Logo-SuperSelect_svg__st0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Logo-SuperSelect_svg__Pfad_44",
  d: "M44.7 4.3h-4v2.5h3.9v3.6h-3.9v2.5h4.2v3.9h-8.6V.4h8.5z",
  className: "Logo-SuperSelect_svg__st0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Logo-SuperSelect_svg__Pfad_45",
  d: "m53.9 17.1-2-5.7h-.7v5.5H47V.4c1.3-.1 3-.2 6-.2 3.8 0 4.9 1.8 4.9 5 0 2.7-.4 4.7-1.9 5.6l2.4 5.9zm-2.7-8.7h1.1c1 0 1.3-.5 1.3-2.4 0-.7-.1-1.4-.2-2.1-.2 0-.5-.1-.9-.1s-.8 0-1.3.1z",
  className: "Logo-SuperSelect_svg__st0"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "Logo-SuperSelect_svg__Gruppe_28",
  transform: "translate(84.871 3.099)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Logo-SuperSelect_svg__Pfad_46",
  d: "M3 16.3c-1.1 0-2.1-.1-3.2-.5v-3.9c1 .4 2.1.6 3.2.6.2 0 .5 0 .7-.1.1-.2.1-.4.1-.6 0-.6-.2-1-1.1-2.1L1.5 8.1C.6 7.1.1 5.9.1 4.5.1 1.7 1.7.1 5 .1c1 0 2.1.1 3.1.4l-.3 3.6c-.7-.1-1.4-.2-2.2-.3q-1.2 0-1.2.9c0 .9.4 1 1 1.9l1.3 1.7c.8 1 1.3 2.2 1.3 3.5-.1 2.5-1.7 4.5-5 4.5",
  className: "Logo-SuperSelect_svg__st0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Logo-SuperSelect_svg__Pfad_47",
  d: "M17.6 4.1h-3.8v2.4h3.7v3.4h-3.7v2.5h4V16h-8V.5h8z",
  className: "Logo-SuperSelect_svg__st0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Logo-SuperSelect_svg__Pfad_48",
  d: "M27 16h-7.3V.5h4v11.9H27z",
  className: "Logo-SuperSelect_svg__st0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Logo-SuperSelect_svg__Pfad_49",
  d: "M36.4 4.1h-3.8v2.4h3.7v3.4h-3.7v2.5h4V16h-8.1V.5h8z",
  className: "Logo-SuperSelect_svg__st0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Logo-SuperSelect_svg__Pfad_50",
  d: "M43.7.2c1 0 2 .2 2.9.5l-.2 3.6Q45.35 4 44.3 4c-1.8 0-2 .6-2 4.8-.1 1.3 0 2.6.2 3.8h.7c1.1 0 2.2-.1 3.3-.4v3.6c-1.1.3-2.3.5-3.4.6-4.6 0-4.8-2.6-4.8-7.5S38.9.2 43.7.2",
  className: "Logo-SuperSelect_svg__st0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Logo-SuperSelect_svg__Pfad_51",
  d: "M56.9 4.1h-2.6v12h-4v-12h-2.6V.4H57z",
  className: "Logo-SuperSelect_svg__st0"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Logo-SuperSelect_svg__Pfad_52",
  d: "M78.8 14.1c-.9-4.4-4.6-6.8-7.6-5.6-.4 0-.7.1-1 .3.2-.2.4-.5.6-.6 2.1-2 6.2-1.5 8.9 1.5.9 1.2 1.6 2.5 2.2 3.9.3-1 .4-2 .4-3 0-.8-.1-1.6-.2-2.5-1.2-.9-2.5-1.7-4-2.3-4.2-1.4-8.2.6-8.6 3.8-.2.3-.2.6-.2.9v.2c0-.1 0-.1-.1-.2v-.1c-1.1-3 1.3-6.7 5.6-7.5q2.25-.3 4.5 0C78 1.5 76.3.5 74.5 0c-1.4.6-2.7 1.3-3.9 2.2-3.2 2.9-3.7 6.9-1.7 9 .2.2.5.4.7.6.2.3.5.5.8.6h-.2c-3.3-.3-5.4-4.4-4-8.6.5-1.3 1.2-2.6 2.1-3.7-1.8.5-3.5 1.5-4.8 2.8-.2 1.4-.2 2.9 0 4.3.8 4.3 4.4 6.7 7.5 5.6.1-.1.2-.1.3-.2.3 0 .5-.1.8-.2-2 2.5-6.4 2.3-9.3-1-.6-.8-1.2-1.7-1.7-2.5-.2-.3-.3-.7-.5-1-.3 1-.4 1.9-.4 2.9 0 .9.1 1.8.3 2.6 1.2.9 2.4 1.6 3.7 2.1 4.2 1.4 8.2-.6 8.6-3.8.2-.3.2-.7.2-1v-.2c.1.4.3.8.3 1.2.4 2.8-2 5.8-5.8 6.6-1.4.2-2.9.2-4.3 0 1.3 1.3 2.8 2.2 4.5 2.8 1.4-.6 2.8-1.3 4-2.3 3.3-2.9 3.6-7.4 1-9.4-.2-.3-.4-.5-.7-.6 3.3.4 5.3 4.4 3.8 8.6-.4.9-.9 1.8-1.4 2.7l-.9 1.2c2-.4 3.7-1.4 5.2-2.9.4-1.4.3-2.8.1-4.3",
  style: {
    fill: "#e30613"
  }
}));
export default SvgLogoSuperSelect;